import { Stack, Text } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

export interface ChartLegendItem {
  id: string;
  label: string;
  color: string;
}

interface ChartLegendProps {
  items: ChartLegendItem[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  className?: string;
}

export function ChartLegend({ items, selectedIds, onToggle, className }: ChartLegendProps) {
  return (
    <Stack
      direction="horizontal"
      gap="lg"
      items="center"
      className={twMerge("flex-wrap", className)}
    >
      {items.map((item) => {
        const selected = selectedIds.includes(item.id);
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onToggle(item.id)}
            className="flex cursor-pointer items-center gap-2"
          >
            <span
              className={`size-3.5 shrink-0 rounded-full border-3 ${
                selected ? "" : "border-dark/20"
              }`}
              style={
                selected ? { borderColor: item.color, backgroundColor: item.color } : undefined
              }
            />
            <Text className="text-secondary">{item.label}</Text>
          </button>
        );
      })}
    </Stack>
  );
}
